var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2887_10526)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "#346F98"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 0.748047,
    width: 58,
    height: 58,
    rx: 8,
    fill: "url(#paint0_linear_2887_10526)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5417 40.623C21.8771 40.623 21.3082 40.3864 20.8349 39.9131C20.3616 39.4399 20.125 38.871 20.125 38.2064V23.1022C20.125 22.8203 20.1703 22.5534 20.2609 22.3017C20.3516 22.05 20.4875 21.8133 20.6687 21.5918L22.3604 19.5376C22.5417 19.3161 22.7481 19.15 22.9797 19.0392C23.2113 18.9284 23.4681 18.873 23.75 18.873H38.25C38.5319 18.873 38.7887 18.9284 39.0203 19.0392C39.2519 19.15 39.4583 19.3161 39.6396 19.5376L41.3312 21.5918C41.5125 21.8133 41.6484 22.05 41.7391 22.3017C41.8297 22.5534 41.875 22.8203 41.875 23.1022V38.2064C41.875 38.871 41.6384 39.4399 41.1651 39.9131C40.6918 40.3864 40.1229 40.623 39.4583 40.623H22.5417ZM23.025 22.498H38.975L37.9479 21.2897H24.0521L23.025 22.498ZM34.0812 35.8501L38.3708 31.5605L34.0812 27.271L32.3292 29.023L34.8667 31.5605L32.3292 34.098L34.0812 35.8501ZM27.9792 35.8501L29.7312 34.098L27.1937 31.5605L29.7312 29.023L27.9792 27.271L23.6896 31.5605L27.9792 35.8501Z",
    fill: "#E9E9E9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2887_10526",
    x: 0.791667,
    y: 0.748047,
    width: 60.4167,
    height: 60.4167,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.20833
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.604167
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.03 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2887_10526"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2887_10526",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2887_10526",
    x1: 31,
    y1: 0.748047,
    x2: 31,
    y2: 58.748,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#38ACFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#007DD6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevelopment);
export default __webpack_public_path__ + "static/media/development.85babfb98ccca892969f0d24b30df164.svg";
export { ForwardRef as ReactComponent };